/**
 * Utility functions for Obraz application
 */

export type Season = 'winter' | 'spring' | 'summer' | 'autumn';

/**
 * Get current season based on current month
 * December-February: winter
 * March-May: spring
 * June-August: summer
 * September-November: autumn
 */
export function getCurrentSeason(): Season {
  const month = new Date().getMonth(); // 0-11

  if (month >= 11 || month <= 1) return 'winter'; // Dec, Jan, Feb
  if (month >= 2 && month <= 4) return 'spring'; // Mar, Apr, May
  if (month >= 5 && month <= 7) return 'summer'; // Jun, Jul, Aug
  return 'autumn'; // Sep, Oct, Nov
}
